import React from "react";
import { Modal, Button } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRecycle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const PaymentMultiClearConfirmationModal = ({ show, onClose, onConfirm, selectedCount }) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Body className="p-4">
                <FalconCloseButton
                    onClick={onClose}
                    size="sm"
                    className="position-absolute top-0 end-0 me-2 mt-2"
                />
                <Flex direction="column" alignItems="center">
                    <div
                        className="rounded-circle bg-subtle-success d-flex flex-center mb-3"
                        style={{ width: "60px", height: "60px" }}
                    >
                        <FontAwesomeIcon icon={faCheckCircle} className="text-success fs-3" />
                    </div>
                    <h5 className="mb-2">Bulk Clear Confirmation</h5>
                    <p className="text-center text-700 fs-10 mb-4">
                        You have selected <strong>{selectedCount}</strong> payments.
                        Are you sure you want to mark all selected payments as cleared?
                        This action will update the status of all associated claims.
                    </p>
                    <Flex className="gap-4">
                        <Button
                            variant="falcon-default"
                            size="sm"
                            className="px-4"
                            onClick={onClose}
                        >
                            No, Cancel
                        </Button>
                        <Button
                            variant="success"
                            size="sm"
                            className="px-4 shadow-none"
                            onClick={onConfirm}
                        >
                            Yes, Confirm All
                        </Button>
                    </Flex>
                </Flex>
            </Modal.Body>
        </Modal>
    );
};

export default PaymentMultiClearConfirmationModal;
